<template>
    <el-form :model="layoutArea" :rules="layoutAreaRules" :label-position="'left'" ref="layoutAreaInfo">
        <div class="simple-form">
            <div class="form-group center" v-if="item != null && item.level == 2">
                <div class="form-label">
                    <label>大区名称</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{layoutArea.firstName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">{{item != null && item.level == 2 ? "小区" : "大区"}}名称</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="name">
                        <el-input :disabled="item.id != null" v-model="layoutArea.name" placeholder="请输入布放区名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">{{item != null && item.level == 2 ? "小区" : "大区"}}编码</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="code">
                        <el-input v-model="layoutArea.code" placeholder="请输入布放区编码"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>所在楼层</label>
                </div>
                <div class="form-value width-2x">
                    <span v-if="item != null && item.level == 2">{{layoutArea.layoutFloorName == null ? "暂无，请在大区维护" : layoutArea.layoutFloorName}}</span>
                    <el-form-item prop="code" v-else>
                        <el-select v-model="layoutArea.layoutFloorId" placeholder="请选择" @change="changeLayoutFloor" filterable clearable>
                            <el-option v-for="item in layoutFloorList" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">需要控温</label>
                </div>
                <div class="form-value width-2x">
                    <el-radio-group v-model="layoutArea.temperFlag">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="layoutArea.temperFlag">
                <div class="form-label">
                    <label class="required">温度低值(°c)</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="temperLow">
                        <el-input class="inline-block width-2x" v-model="layoutArea.temperLow" placeholder="请输入温度" @change="temperLowChange()"></el-input>
                    </el-form-item>
                    <span class="inline-block font-orange">只保留两位小数</span>
                </div>
            </div>
            <div class="form-group center" v-if="layoutArea.temperFlag">
                <div class="form-label">
                    <label class="required">温度高值(°c)</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="temperHigh">
                        <el-input class="inline-block width-2x" v-model="layoutArea.temperHigh" placeholder="请输入温度" @change="temperHighChange()"></el-input>
                    </el-form-item>
                    <span class="inline-block font-orange">只保留两位小数</span>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-retailer-layout-area-save',
        desc: '',
        props: {
            item: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                layoutArea: {
                    temperFlag: false
                },
                layoutFloorList: [],
                layoutAreaRules: {
                    name: [{validator: checkNull, trigger: 'blur'}],
                    code: [{validator: checkNull, trigger: 'blur'}],
                    temperLow: [{validator: checkNull, trigger: 'blur'}],
                    temperHigh: [{validator: checkNull, trigger: 'blur'}]
                }
            }
        },
        created: function () {
            this.getLayoutFloorList();
            //
            this.getLayoutArea();
        },
        methods: {
            // 温度低值校验
            temperLowChange: function () {
                let layoutArea = this.layoutArea;
                let temperLow = layoutArea.temperLow;
                if(!Utils.isNoB(temperLow)) {
                    let low = temperLow;
                    if(low.indexOf('-') > -1) {
                        low = low.substring(1, low.length);
                    }
                    if(Utils.isMoneyStr(low)) {
                        let temperLowF = parseFloat(temperLow);
                        layoutArea.temperLow = temperLowF.toFixed(2);
                        let temperHigh = layoutArea.temperHigh;
                        if(!Utils.isNoB(temperHigh)) {
                            let temperHighF = parseFloat(temperHigh);
                            if(temperLowF > temperHighF) {
                                layoutArea.temperLow = null;
                                MsgBox.warning("温度低值要小于温度高值!");
                            }
                        }
                    } else {
                        layoutArea.temperLow = null;
                        MsgBox.warning("请输入正确的温度!");
                    }
                    //
                    this.layoutArea = Utils.merge({}, layoutArea);
                }
            },
            // 温度高值校验
            temperHighChange: function () {
                let layoutArea = this.layoutArea;
                let temperHigh = layoutArea.temperHigh;
                if(!Utils.isNoB(temperHigh)) {
                    let high = temperHigh;
                    if(high.indexOf('-') > -1) {
                        high = high.substring(1, high.length);
                    }
                    if(Utils.isMoneyStr(high)) {
                        let temperHighF = parseFloat(temperHigh);
                        layoutArea.temperHigh = temperHighF.toFixed(2);
                        let temperLow = layoutArea.temperLow;
                        if(!Utils.isNoB(temperLow)) {
                            let temperLowF = parseFloat(temperLow);
                            if(temperLowF > temperHighF) {
                                layoutArea.temperHigh = null;
                                MsgBox.warning("温度高值要大于温度低值!");
                            }
                        }
                    } else {
                        layoutArea.temperHigh = null;
                        MsgBox.warning("请输入正确的温度!");
                    }
                    //
                    this.layoutArea = Utils.merge({}, layoutArea);
                }
            },
            getLayoutArea: function () {
                let self = this;
                let item = self.item;
                if(!Utils.isNoB(item.id)) {
                    //
                    let theLoad = MsgBox.loading();
                    merchtComnApi.getRetailerLayoutArea(item.id, function (result) {
                        theLoad.hide();
                        if(result.type === 'info') {
                            let layoutArea = result.data;
                            //
                            if(!Utils.isNoB(layoutArea) && !Utils.isNoB(layoutArea.temperLow)) {
                                layoutArea.temperLow = parseFloat(layoutArea.temperLow).toFixed(2);
                            }
                            if(!Utils.isNoB(layoutArea) && !Utils.isNoB(layoutArea.temperHigh)) {
                                layoutArea.temperHigh = parseFloat(layoutArea.temperHigh).toFixed(2);
                            }
                            if(layoutArea.layoutFloorId <= 0 || Utils.isNoB(layoutArea.layoutFloorId)) {
                                layoutArea.layoutFloorId = null;
                            }
                            //
                            layoutArea.firstName = item.firstName;
                            self.layoutArea = Utils.merge({}, layoutArea);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else {
                    if(!Utils.isNoB(item) && !Utils.isNoB(item.parentId)) {
                        //
                        if(!Utils.isNoB(item.temperLow)) {
                            item.temperLow = parseFloat(item.temperLow).toFixed(2);
                        }
                        if(!Utils.isNoB(item.temperHigh)) {
                            item.temperHigh = parseFloat(item.temperHigh).toFixed(2);
                        }
                        //
                        self.layoutArea = Utils.merge({}, item);
                    }
                }
            },
            // 获取楼层
            getLayoutFloorList: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                merchtComnApi.getRetailerLayoutFloorList({}, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        self.layoutFloorList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['layoutAreaInfo'].validate(function (valid) {
                    if(valid) {
                        let layoutArea = self.layoutArea;
                        if(!Utils.isNoB(layoutArea.name)) {
                            layoutArea.name = layoutArea.name.trim();
                        }
                        if(!Utils.isNoB(layoutArea.code)) {
                            layoutArea.code = layoutArea.code.trim();
                        }
                        //
                        result.type = "info";
                        result.data = layoutArea;
                    } else {
                        result.type = "warn";
                        result.message = "数据缺失，请填写！";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/layoutArea/RetailerLayoutAreaSave.vue